import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'customer-app-collapsed-bar',
  templateUrl: './collapsed-bar.component.html',
  styleUrls: ['./collapsed-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule]
})
export class CollapsedBarComponent {
  titles = input<string[]>();
  toggleItem = output<number>();

  openMenu(i: number): void {
    this.toggleItem.emit(i);
  }
}
